export default "__VITE_ASSET__021cbf36__"